// Core Imports
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import clsx from "clsx";

// Bootstrap Components
import { Container, Navbar, Nav } from "react-bootstrap";

// MUI Components
import {
  Drawer,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListSubheader,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

// Icons & Media
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
import Logo from "../assets/images/logo/logo-light-r.png";
import LogoColor from "../assets/images/logo/logo-dark.jpeg";
import MenuIcon from "../assets/images/menu-icon-top.svg";
import LogoSm from "../assets/images/logo/sad_logo_sm.svg"

// Drawer styles using makeStyles
const useStyles = makeStyles(() => ({
  list: {
    width: 300,
  },
  fullList: {
    width: "auto",
  },
}));

const Header = () => {
  const classes = useStyles();
  const location = useLocation().pathname;

  // State to control the drawer menu
  const [drawerState, setDrawerState] = useState({ left: false });

  // State for active menu links
  const [activeLinks, setActiveLinks] = useState({
    home: "",
    aboutus: "",
    services: "",
    gallery: "",
    contact: "",
  });

  // Set active class based on current URL
  useEffect(() => {
    switch (location) {
      case "/":
        setActiveLinks({ home: "active" });
        break;
      case "/about-us":
        setActiveLinks({ aboutus: "active" });
        break;
      case "/services":
        setActiveLinks({ services: "active" });
        break;
      case "/gallery":
        setActiveLinks({ gallery: "active" });
        break;
      case "/contact-us":
        setActiveLinks({ contact: "active" });
        break;
      default:
        setActiveLinks({});
    }
  }, [location]);

  // Handle drawer toggle
  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setDrawerState({ ...drawerState, [anchor]: open });
  };

  // Drawer List Component
  const drawerList = (anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === "top" || anchor === "bottom",
      })}
      role="presentation"
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List
        component="nav"
        aria-labelledby="nested-list-subheader"
        subheader={
          <ListSubheader component="div" className="text-center">
            <img src={Logo} alt="SADP Logo" className="img-fluid" />
          </ListSubheader>
        }
      >
        <Divider className="mt-4" />
        {/* Drawer navigation links */}
        {[
          { text: "Home", path: "/" },
          { text: "About Us", path: "/about-us" },
          { text: "Services", path: "/services" },
          { text: "Gallery", path: "/gallery" },
          { text: "Contact Us", path: "/contact-us" },
        ].map(({ text, path }) => (
          <a key={text} href={path}>
            <ListItem button>
              <ListItemIcon>
                <KeyboardReturnIcon className="fa-flip-horizontal" />
              </ListItemIcon>
              <ListItemText primary={text} />
            </ListItem>
          </a>
        ))}
      </List>
    </div>
  );

  return (
    <div className="header sticky">
      <Container>
        <Navbar expand="lg">
          {/* Drawer icon for mobile */}
          <div>
            <img
              src={MenuIcon}
              alt="Menu"
              className="d-block d-lg-none menu-icon"
              onClick={toggleDrawer("left", true)}
            />
            <Drawer
              anchor="left"
              open={drawerState.left}
              onClose={toggleDrawer("left", false)}
            >
              {drawerList("left")}
            </Drawer>
          </div>

          {/* Logo */}
          <Navbar.Brand href="/">
            <img src={Logo} alt="RMC Pro Logo" className="mlogo" style={{ height: "60px"}}/>
          </Navbar.Brand>

          {/* Desktop navigation */}
          <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
            <Nav>
              <Nav.Link href="/" className={activeLinks.home}>
                Home
              </Nav.Link>
              <Nav.Link href="/about-us" className={activeLinks.aboutus}>
                About Us
              </Nav.Link>
              <Nav.Link href="/services" className={activeLinks.services}>
                Services
              </Nav.Link>
              <Nav.Link href="/gallery" className={activeLinks.gallery}>
                Gallery
              </Nav.Link>
              <Nav.Link href="/contact-us" className={activeLinks.contact}>
                Contact Us
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </Container>
    </div>
  );
};

export default Header;
